import http from '../_http_v2';

const report = {
  report: (m) => { return http.post(`console/wmds/report`, m); }
}

export default report

export { report }